import { EditOutlined as EditOutlinedIcon } from '@mui/icons-material';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { SecondaryActionButton } from '../../../design/components/button/SecondaryAction';

import type { SecondaryActionProps } from '../../../design/components/button/SecondaryAction';
import type { FunctionComponent } from 'react';

type EditButtonProps = Omit<SecondaryActionProps, 'label' | 'startIcon'>;

export const EditButton: FunctionComponent<EditButtonProps> = ({ onClick, ...props }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <SecondaryActionButton
            aria-label="Edit"
            label={translate('common.edit')}
            startIcon={<EditOutlinedIcon color="action" />}
            onClick={onClick}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
        />
    );
};
